import { render, staticRenderFns } from "./UiSearch.vue?vue&type=template&id=cb0ddc66&"
import script from "./UiSearch.vue?vue&type=script&lang=js&"
export * from "./UiSearch.vue?vue&type=script&lang=js&"
import style0 from "./UiSearch.vue?vue&type=style&index=0&id=cb0ddc66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports